var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"topOfPage",staticClass:"relative",class:_vm.pos === 'relMob' && _vm.mobile ? 'bg-realBlack' : '',attrs:{"id":"app"}},[(!_vm.noFoot)?_c('Nav',{attrs:{"bg":_vm.bg,"nbg":_vm.nbg,"pos":_vm.pos,"logo":_vm.logo,"blur":_vm.blur}}):_vm._e(),_c('router-view'),(!_vm.noNav)?_c('Footer'):_vm._e(),_c('Modal'),_c('SuccessModal')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }